import { render } from "./NewCrawlBarDuration.vue?vue&type=template&id=57a1678d&scoped=true"
import script from "./NewCrawlBarDuration.vue?vue&type=script&lang=js"
export * from "./NewCrawlBarDuration.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-57a1678d"

export default script